import { config } from '@js/state';
import {
  enablePointerEvents,
  disablePointerEvents,
} from '@utils/pointer-events-control';

let correctPodium = 2;

export default class TutorialScene extends Phaser.Scene {
  constructor() {
    super({ key: 'TutorialScene' });
  }

  preload() {}

  loadRemainingGameSceneAssets() {
    this.load.image('qnImage2', 'assets/GameSceneAssets/qnImage2.png');
    this.load.image('qnImage3', 'assets/GameSceneAssets/qnImage3.png');
    this.load.image('qnImage4', 'assets/GameSceneAssets/qnImage4.png');
    this.load.image('qnImage5', 'assets/GameSceneAssets/qnImage5.png');
    this.load.image('qnImage6', 'assets/GameSceneAssets/qnImage6.png');
    this.load.image('qnImage7', 'assets/GameSceneAssets/qnImage7.png');
    this.load.image('qnImage8', 'assets/GameSceneAssets/qnImage8.png');
    this.load.image('qnImage9', 'assets/GameSceneAssets/qnImage9.png');
    this.load.image('qnImage10', 'assets/GameSceneAssets/qnImage10.png');
    this.load.image('qnImageTut', 'assets/GameSceneAssets/qnImageTut.png');

    this.load.image('hintStyle1', 'assets/GameSceneAssets/hintImages/hintStyle1.png');
    this.load.image('hintStyle2', 'assets/GameSceneAssets/hintImages/hintStyle2.png');
    this.load.image('hintStyle3', 'assets/GameSceneAssets/hintImages/hintStyle3.png');
    this.load.image('hintStyle4', 'assets/GameSceneAssets/hintImages/hintStyle4.png');
    this.load.image('hintStyle5', 'assets/GameSceneAssets/hintImages/hintStyle5.png');
    this.load.image('hintStyle7', 'assets/GameSceneAssets/hintImages/hintStyle7.png');
    this.load.image('hintStyle9', 'assets/GameSceneAssets/hintImages/hintStyle9.png');
    this.load.image('hintStyle10', 'assets/GameSceneAssets/hintImages/hintStyle10.png');
    this.load.image('hintStyle12', 'assets/GameSceneAssets/hintImages/hintStyle12.png');
  }

  create() {
    enablePointerEvents();

    this.UiSceneID = this.scene.get('UiScene');

    this.time.delayedCall(
      500,
      () => {
        this.UiSceneID.q.setTexture('tutText1');
        this.UiSceneID.textHolderTween(1002, 500, 50);
      },
      [],
      this,
    );

    config.audio.backgroundMusic = this.sound
      .add('backgroundMusic')
      .setVolume(0.1)
      .setLoop(true);
    config.audio.correctSound = this.sound.add('correctSound').setVolume(0.1);
    config.audio.confettiSound = this.sound.add('confettiSound').setVolume(0.05);

    config.audio.backgroundMusic.play();

    this.loadRemainingGameSceneAssets();
    this.load.start();

    this.add.image(config.width / 2, config.height / 2, 'gameBackground');
    this.qnImage = this.add
      .sprite(640, 254, 'qnImage1')
      .setOrigin(0.5, 0.5)
      .setAlpha(1);

    this.selectionStroke = this.add
      .sprite(271.5 + 187 * correctPodium, 368, 'selectionStroke')
      .setOrigin(0)
      .setVisible(false);

    this.podium1 = this.add.sprite(278, 463, 'podium').setOrigin(0);
    this.podium2 = this.add.sprite(465, 463, 'podium').setOrigin(0);
    this.podium3 = this.add.sprite(652, 463, 'podium').setOrigin(0);
    this.podium4 = this.add.sprite(839, 463, 'podium').setOrigin(0);

    this.cardHolder1 = this.add.sprite(306, 374, 'cardHolder').setOrigin(0);
    this.cardHolder2 = this.add.sprite(493, 374, 'cardHolder').setOrigin(0);
    this.cardHolder3 = this.add.sprite(680, 374, 'cardHolder').setOrigin(0);
    this.cardHolder4 = this.add.sprite(867, 374, 'cardHolder').setOrigin(0);

    this.card1 = this.add.sprite(311, 379, 'defaultCard').setOrigin(0);
    this.card2 = this.add.sprite(498, 379, 'defaultCard').setOrigin(0);
    this.card3 = this.add.sprite(685, 379, 'defaultCard').setOrigin(0);
    this.card4 = this.add.sprite(872, 379, 'defaultCard').setOrigin(0);

    this.light1 = this.add.sprite(328, 508, 'yellowLight').setOrigin(0);
    this.light2 = this.add.sprite(515, 508, 'yellowLight').setOrigin(0);
    this.light3 = this.add.sprite(702, 508, 'yellowLight').setOrigin(0);
    this.light4 = this.add.sprite(889, 508, 'yellowLight').setOrigin(0);

    this.pod1nr = this.add
      .text(355, 424 - 18, '6', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod2nr = this.add
      .text(542, 424 - 18, '3', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod3nr = this.add
      .text(729, 424 - 18, '6', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod4nr = this.add
      .text(916, 424 - 18, '3', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);

    this.pod1dr = this.add
      .text(355, 424 + 18, '2', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod2dr = this.add
      .text(542, 424 + 18, '6', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod3dr = this.add
      .text(729, 424 + 18, '3', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod4dr = this.add
      .text(916, 424 + 18, '2', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);

    this.pod1Line = this.add
      .text(355, 424, '—', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod2Line = this.add
      .text(542, 424, '—', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod3Line = this.add
      .text(729, 424, '—', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);
    this.pod4Line = this.add
      .text(916, 424, '—', {
        fontFamily: 'font1',
        fontSize: '24px',
        fill: '#2b2b2b',
      })
      .setOrigin(0.5, 0.5);

    this.allCardsGroup = this.add.container(0, 0, [
      this.selectionStroke,
      this.podium1,
      this.podium2,
      this.podium3,
      this.podium4,
      this.light1,
      this.light2,
      this.light3,
      this.light4,
      this.cardHolder1,
      this.card1,
      this.cardHolder2,
      this.card2,
      this.cardHolder3,
      this.card3,
      this.cardHolder4,
      this.card4,
      this.pod1nr,
      this.pod2nr,
      this.pod3nr,
      this.pod4nr,
      this.pod1dr,
      this.pod2dr,
      this.pod3dr,
      this.pod4dr,
      this.pod1Line,
      this.pod2Line,
      this.pod3Line,
      this.pod4Line,
    ]);

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, 'overlay')
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(true)
      .setInteractive();

    this.confetti = this.add
      .sprite(355 + 187 * correctPodium, 0, 'confetti')
      .setOrigin(0.5, 0)
      .setVisible(false)
      .setScale(0.5, 1);

    this.spotlight = this.add
      .sprite(355 + 187 * correctPodium, 71, 'spotlight')
      .setOrigin(0.5, 0)
      .setAlpha(0)
      .setScale(0);

    this.time.delayedCall(
      3000,
      () => {
        this.UiSceneID.q.setTexture('tutText2');
        this.qnImage.setDepth(1);

        this.time.delayedCall(
          3500,
          () => {
            this.tutQuestionAsk();
          },
          [],
          this,
        );
      },
      [],
      this,
    );

    this.selectionStroke.on('pointerup', () => {
      config.audio.correctSound.play();

      this.UiSceneID.q.setTexture('tutText4');

      if (correctPodium == 0) {
        this.light1.setTexture('greenLight');
      } else if (correctPodium == 1) {
        this.light2.setTexture('greenLight');
      } else if (correctPodium == 2) {
        this.light3.setTexture('greenLight');
      } else if (correctPodium == 3) {
        this.light4.setTexture('greenLight');
      }

      this.overlay.setVisible(false);

      this.UiSceneID.runCorrectUi();

      this.time.delayedCall(
        4000,
        () => {
          this.tweens.add({
            targets: this.spotlight,
            alpha: 0,
            ease: 'Cubic',
            duration: 500,
          });
        },
        [],
        this,
      );

      this.tweens.add({
        targets: this.spotlight,
        delay: 0,
        scale: { from: 0, to: 1 },
        alpha: { from: 1, to: 1 },
        ease: 'Cubic',
        duration: 1000,
        onComplete: () => {
          config.audio.confettiSound.play();
          this.confetti.play('confettiPop').setVisible(true);
        },
      });

      this.time.delayedCall(
        5500,
        () => {
          disablePointerEvents();
          this.scene.stop('TutorialScene');
          this.scene.start('GameScene');
          this.scene.bringToTop('UiScene');
        },
        [],
        this,
      );

      this.selectionStroke.removeInteractive();
    });

    this.anims.create({
      key: 'confettiPop',
      frames: this.anims.generateFrameNames('confetti', {
        start: 0,
        end: 300,
        zeroPad: 0,
        prefix: 'verticalConfetti',
        suffix: '.png',
      }),
      frameRate: 100,
      repeat: 0,
    });
  }

  tutQuestionAsk() {
    this.UiSceneID.q.setTexture('tutText3');
    this.allCardsGroup.setDepth(1);
    this.selectionStroke.setVisible(true).setInteractive({ cursor: 'pointer' });
  }

  update() {}
}
